var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sfjaisle"},[_c('h2',[_vm._v("这是水肥机配置页面")])])
}]

export { render, staticRenderFns }